var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unload-content__welcome"},[_c('r-title',{attrs:{"type":"title-2","color-type":"subhead"}},[_vm._v(" Для начала работы выберите объект в панели слева ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }